import { CopyIcon } from '@radix-ui/react-icons';
import { IconButton } from '@radix-ui/themes';

const CopyButton = ({ value }: { value: string }) => (
  <IconButton
    size="1"
    aria-label="Copy value"
    color="gray"
    variant="ghost"
    onClick={() => navigator.clipboard.writeText(value)}
  >
    <CopyIcon />
  </IconButton>
);

export default CopyButton;
